var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back",
    transform: "translate(24672 20651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_27721",
    "data-name": "Rectangle 27721",
    transform: "translate(-24672 -20651)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_81442",
    "data-name": "Path 81442",
    d: "M9,6.5V4l5,5L9,14V11.5H4v-5Z",
    transform: "translate(-24653 -20632) rotate(180)",
    fill: "#ff9800"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/back.8984e642.svg";
export { ForwardRef as ReactComponent };